import { PDFLinkService } from 'pdfjs-dist/lib/web/pdf_link_service';
export default PDFLinkService;